import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: 'max-content',
      borderRadius: palette.borderRadius.default,
      padding: '10px',
      color: palette.text.white,
      fontWeight: 700
    },
    Blue: {
      background: palette.common.primaryBlue
    },
    White: {
      color: palette.title.primary
    },
    isNotes: {
      gap: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
